import { c as _c } from "react/compiler-runtime";
import { Button, IconButton, Menu, MenuSection, SingleSelectItem, SortDownIcon, SortUpIcon } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { TableEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";

/** Information about a sort direction */

/** Information about each sort direction */
const SORT_DIRECTION_INFO = {
  asc: {
    label: "Ascending",
    icon: <SortDownIcon />,
    newSortDirection: "desc"
  },
  desc: {
    label: "Descending",
    icon: <SortUpIcon />,
    newSortDirection: "asc"
  }
};
/**
 * @returns The sort item to show: the given one if the options offer it, otherwise the first option
 * in ascending order, or undefined if there are no options at all.
 */
function getDisplayedSortItem(sortOptions, sortItem) {
  // Typed as optional, as the options can be a filtered subset of all the fields
  const selectedOption = sortItem ? sortOptions[sortItem.field] : undefined;
  if (sortItem && selectedOption && sortItem.sort in SORT_DIRECTION_INFO) {
    return sortItem;
  }
  const firstOption = Object.values(sortOptions)[0];
  return firstOption ? {
    field: firstOption.field,
    sort: "asc"
  } : undefined;
}

/**
 * Component that allows users to select a sort field and toggle between ascending and descending directions.
 */
export function SortSelector(t0) {
  const $ = _c(43);
  const {
    sortOptions,
    sortItem: requestedSortItem,
    setSortItem,
    subjectType,
    trackingViewMode: t1
  } = t0;
  const trackingViewMode = t1 === undefined ? "cards" : t1;
  const {
    trackEvent
  } = useTrackEvent();
  const [menuAnchor, setMenuAnchor] = useState(null);
  let t2;
  if ($[0] !== requestedSortItem || $[1] !== sortOptions) {
    t2 = getDisplayedSortItem(sortOptions, requestedSortItem);
    $[0] = requestedSortItem;
    $[1] = sortOptions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const displayedSortItem = t2;
  if (!displayedSortItem) {
    return null;
  }
  const sortItem = displayedSortItem;
  let t3;
  if ($[3] !== setSortItem || $[4] !== sortItem.field || $[5] !== sortItem.sort || $[6] !== subjectType || $[7] !== trackEvent || $[8] !== trackingViewMode) {
    t3 = function handleSortDirectionToggle() {
      const newSortDirection = SORT_DIRECTION_INFO[sortItem.sort].newSortDirection;
      trackEvent({
        name: TableEvents.sortItems,
        props: {
          subject: subjectType,
          sortBy: sortItem.field,
          sortOrder: newSortDirection,
          viewMode: trackingViewMode
        }
      });
      setSortItem({
        field: sortItem.field,
        sort: newSortDirection
      });
    };
    $[3] = setSortItem;
    $[4] = sortItem.field;
    $[5] = sortItem.sort;
    $[6] = subjectType;
    $[7] = trackEvent;
    $[8] = trackingViewMode;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleSortDirectionToggle = t3;
  let t4;
  if ($[10] !== setSortItem || $[11] !== subjectType || $[12] !== trackEvent || $[13] !== trackingViewMode) {
    t4 = function handleSortFieldChange(newField) {
      trackEvent({
        name: TableEvents.sortItems,
        props: {
          subject: subjectType,
          sortBy: newField,
          sortOrder: "asc",
          viewMode: trackingViewMode
        }
      });
      setSortItem({
        field: newField,
        sort: "asc"
      });
      setMenuAnchor(null);
    };
    $[10] = setSortItem;
    $[11] = subjectType;
    $[12] = trackEvent;
    $[13] = trackingViewMode;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleSortFieldChange = t4;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      width: "fit-content"
    };
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = menuAnchor !== null;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => setMenuAnchor(event.currentTarget);
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = menuAnchor !== null ? "action.selected" : undefined;
  let t9;
  if ($[17] !== t8) {
    t9 = {
      backgroundColor: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = SORT_DIRECTION_INFO[sortItem.sort];
  const t11 = sortOptions[sortItem.field];
  let t12;
  if ($[19] !== t10.icon || $[20] !== t11.label || $[21] !== t6 || $[22] !== t9) {
    t12 = <Button variant="neutralGhost" size="s" data-testid="sort-label" aria-expanded={t6} onClick={t7} sx={t9} icon={t10.icon}>{t11.label}</Button>;
    $[19] = t10.icon;
    $[20] = t11.label;
    $[21] = t6;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = menuAnchor !== null;
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setMenuAnchor(null);
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = SORT_DIRECTION_INFO[sortItem.sort];
  let t17;
  if ($[26] !== handleSortDirectionToggle || $[27] !== t16.icon) {
    t17 = <MenuSection><Box sx={t15}>Sort by<IconButton onClick={handleSortDirectionToggle} size="s">{t16.icon}</IconButton></Box></MenuSection>;
    $[26] = handleSortDirectionToggle;
    $[27] = t16.icon;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== sortOptions) {
    t18 = Object.values(sortOptions);
    $[29] = sortOptions;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== handleSortFieldChange || $[32] !== sortItem.field || $[33] !== t18) {
    t19 = t18.map(option => <SingleSelectItem key={option.field} label={option.label} value={option.field} selectedValue={sortItem.field} onClick={() => handleSortFieldChange(option.field)} />);
    $[31] = handleSortFieldChange;
    $[32] = sortItem.field;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== menuAnchor || $[36] !== t13 || $[37] !== t17 || $[38] !== t19) {
    t20 = <Menu anchorEl={menuAnchor} open={t13} onClose={t14} minWidth="200px">{t17}{t19}</Menu>;
    $[35] = menuAnchor;
    $[36] = t13;
    $[37] = t17;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t12 || $[41] !== t20) {
    t21 = <Box sx={t5}>{t12}{t20}</Box>;
    $[40] = t12;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  return t21;
}